import { createSelector } from '@reduxjs/toolkit';

import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { TemplateListPartial } from 'dashboard/models/template';
import { RootState } from 'dashboard/redux/store';

const getLegacyTemplates = (state: RootState): TemplateListPartial[] =>
  state.inquiryTemplates.legacyTemplates;
const getInquiryTemplates = (state: RootState): InquiryTemplate[] =>
  state.inquiryTemplates.inquiryTemplates;

export const dynamicFlowTemplatesOnlySelector = (state: RootState): boolean =>
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  state.featureFlags?.featureFlags['dashboard:dynamic-flow-templates-only'];

// This can be removed after all templates are migrated to be inquiry templates.
// Note that this is distinct from the Organization version of this selector, and reads from filtered state.
export const getAllTemplates = createSelector(
  [getLegacyTemplates, getInquiryTemplates],
  (templates, inquiryTemplates): Array<TemplateListPartial | InquiryTemplate> =>
    [...templates, ...inquiryTemplates].sort((a, b) =>
      a.attributes.name.localeCompare(b.attributes.name),
    ),
);
